import HandleErrorApi from "./HandleErrorApi";

class GroupReportApi {
    api = new HandleErrorApi();

    // Создание группового отчета
    createGroup(data = {domains: null, base: null, name: null, emptyReport: null})
    {
        return this.api.post('/report/group', data);
    }

    getReportList(data)
    {
        return this.api.get('/report/group/list', data);
    }

    getReportKeywords(rid, data)
    {
        return this.api.get('/report/group/organic/keywords/' + rid, data);
    }

    removeKeywords(rid, data)
    {
        return this.api.post('/report/group/delete/keys/' + rid, data);
    }

    /**
     * Смена владельца группового отчета между корпоративными пользователями
     */
    changeReportOwner(reportId = null, data = {userEmail: null})
    {
        return this.api.post('/report/group/owner/' + reportId, data);
    }

    /**
     * Переименование отчёта
     * @param {string} reportUid
     * @param data{{
     *     name: String,
     * }}
     * @returns {Promise<*>}
     */
    renameReport(reportUid, data) {
        return this.api.patch(sprintf('/report/group/%s', reportUid), data);
    }

    /**
     *
     * @param {string} reportUid
     * @returns {Promise<*>}
     */
    recalcConcurents(reportUid)
    {
        return this.api.post(sprintf('/report/group/recalc_concurents/%s', reportUid));
    }
}

export default new GroupReportApi();
